export type FormValues = {
    certificateType: string;
    requestDate?: string;
};

export const getInitialValues = (): FormValues => ({
    certificateType: '',
    requestDate: '',
});
